var _style, _path, _path2, _path3, _path4, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThighs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "thighs_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 148 148",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".thighs_svg__st0{fill:none;stroke:var(--color-text);stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "thighs_svg__st0",
    d: "M120.8 47.3c-2.2-10.8-1.5-32.4-1.5-32.4M31.1 14.9s.2 21.6-2 32.4M125 69.1c-.4-10.6-4.2-21.8-4.2-21.8l-1.2.3c-29.7 7.8-60.9 7.7-90.6-.3 0 0-6 9.3-5.9 21.8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "thighs_svg__st0",
    d: "M125 69.1s-22.1-.1-35.2 16.4c-3.8 4.8-9.6 7.7-15.7 7.7-6.2 0-11.9-2.9-15.7-7.7C45.2 69 23.1 69.1 23.1 69.1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63 81.8c2.7 3.5 6.8 5.4 11.1 5.4s8.3-2 11.1-5.4c10.2-12.9 24.9-16.9 33.3-18.1-.5-3.4-1.2-6.6-1.8-9.2C103 57.7 89 59.3 75 59.3c-14.4 0-28.7-1.7-42.7-5.1-1 2.3-2.1 5.6-2.7 9.4 8.3 1.3 23.1 5.2 33.4 18.2z",
    fill: "var(--color-icon-primary)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "thighs_svg__st0",
    d: "M23.4 68.9c-.8 4-1.8 7.9-2.8 11.8a131.3 131.3 0 00-2.7 50.7M68.2 92.3s-2.2 27.8-13.4 40.8M94.5 108.2l8 7.1-6.4 8.3M77.9 111.7c.8 3.3 6.9 4.8 15.4 4.5M119.5 102l-3.8 10 9.5 4.4M124.3 108.5c7.7-3.6 12.3-7.9 11.5-11.1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "thighs_svg__st0",
    d: "M130.9 97.3c-.4-3.8-1.1-7.5-2-11.2-1.4-5.8-2.9-11.5-4.1-17.3M127.8 131.4c2.6-8.8 3.8-18 3.6-27.1"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "thighs_svg__st0",
    d: "M87.8 123.6c1.6 3.5 3.5 6.8 5.8 9.5M80.3 92.3s0 11.1 3.8 23.1"
  }))));
}
export default SvgThighs;